const ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

/** What `newFirestoreId` produces, and Firestore's own auto-ids look like. */
export const FIRESTORE_ID_PATTERN = /^[A-Za-z0-9]{20}$/
const ID_LENGTH = 20
// The largest multiple of 62 that fits in a byte; bytes at or above it are
// dropped so every character is equally likely.
const MAX_BYTE = 256 - (256 % ID_CHARS.length)

/**
 * A new id in the same shape as Firestore's auto-ids: 20 characters of
 * `[A-Za-z0-9]`, from a cryptographic source. For ids of things that live
 * inside a document rather than as one (e.g. sub timers on a cue), so every id
 * in the app looks alike. Works in browsers and Node.
 */
export function newFirestoreId(): string {
  let id = ''
  while (id.length < ID_LENGTH) {
    for (const byte of crypto.getRandomValues(new Uint8Array(40))) {
      if (byte < MAX_BYTE && id.length < ID_LENGTH) id += ID_CHARS.charAt(byte % ID_CHARS.length)
    }
  }
  return id
}
